/* @ngInject */
export default function ($scope, AuthService, StaffReportsServiceUsersService, StaffReportsEmployeesService, DataTablesService, LayoutService, STATUSES, ReportsService, $timeout, StatusService, toastr, PreferencesService) {
	LayoutService.setTitle('Service Users Report');
	LayoutService.getPageHeader()
	             .setDescription('Fields marked as "N/A" are not yet available in CM3.');
	LayoutService.getPageHeader()
	             .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-sync-alt"></i> Update</button>');
	LayoutService.getPageHeader()
	             .setBreadcrumbs([
		             {
			             route:       'staff.dashboard',
			             displayName: 'Dashboard',
		             },
		             {
			             route:       null,
			             displayName: 'Reports',
		             },
		             {
			             route:       'staff.reports.serviceUsers',
			             displayName: 'Service Users Report',
		             },
	             ]);

	const financialYear = ReportsService.financialYear();

	$scope.cachedStart = $scope.start = financialYear.start;
	$scope.cachedEnd   = $scope.end = financialYear.end;

	$scope.unloadReports = () => {
		$scope.reportLoaded = {
			summariesNowHeadcount:        false,
			summariesNowRegions:          false,
			summariesNowPrograms:         false,
			summariesHistoricalHeadcount: false,
			summariesHistoricalRegions:   false,
			summariesHistoricalPrograms:  false,
			summariesExited:              false,
			summariesTurnover:            false,
			summariesAssessorVisits:      false,
			summariesEvaluations:         false,
			individualsActive:            false,
			individualsInactive:          false,
			individualsFinished:          false,
			individualsNDIS:              false,
			individualsIcare:             false,
			individualsRegionalHours:     false,
			othersHighestId:              false,
		};
	};

	$scope.mapMonthHeaders = (monthHeaders, start) => {
		if (typeof start === 'undefined') {
			start = 1;
		}

		let output = {};

		monthHeaders.forEach((month, index) => {
			output[month] = index + start;
		});

		return output;
	};

	$scope.reportLoaded = {};

	$scope.activeTabs = {
		summaries:   0,
		individuals: 0,
	};

	$scope.$watch('activeTabs.summaries', () => {
		$timeout(() => {
			$scope.handleTabs();
		});
	});

	$scope.$watch('activeTabs.individuals', () => {
		$timeout(() => {
			$scope.handleTabs();
		});
	});

	$scope.handleTabs = () => {
		switch ($scope.activeTabs.summaries) {
			case 0: {
				$scope.reportLoaded.summariesNowHeadcount = true;
				$scope.reportLoaded.summariesNowRegions   = true;
				$scope.reportLoaded.summariesNowPrograms  = true;

				break;
			}

			case 1: {
				$scope.reportLoaded.summariesHistoricalHeadcount = true;

				break;
			}

			case 2: {
				$scope.reportLoaded.summariesExited = true;

				break;
			}

			case 3: {
				$scope.reportLoaded.summariesHistoricalRegions = true;

				break;
			}

			case 4: {
				$scope.reportLoaded.summariesHistoricalPrograms = true;

				break;
			}

			case 5: {
				$scope.reportLoaded.summariesTurnover = true;

				break;
			}

			case 6: {
				$scope.reportLoaded.summariesAssessorVisits = true;

				break;
			}

			case 7: {
				$scope.reportLoaded.summariesEvaluations = true;

				break;
			}
		}

		switch ($scope.activeTabs.individuals) {
			case 0: {
				$scope.reportLoaded.individualsActive = true;

				break;
			}

			case 1: {
				$scope.reportLoaded.individualsInactive = true;

				break;
			}

			case 2: {
				$scope.reportLoaded.individualsFinished = true;

				break;
			}

			case 3: {
				$scope.reportLoaded.individualsNDIS = true;

				break;
			}

			case 4: {
				$scope.reportLoaded.individualsIcare = true;

				break;
			}

			case 5: {
				$scope.reportLoaded.individualsRegionalHours = true;

				break;
			}
		}
	};

	$scope.refresh = () => {
		$scope.cachedStart = $scope.start;
		$scope.cachedEnd   = $scope.end;

		$scope.dateRange = {
			start: $scope.cachedStart,
			end:   $scope.cachedEnd,
		};

		$scope.unloadReports();

		$timeout(() => {
			$scope.reportLoaded.othersHighestId = true;
			$scope.handleTabs();
		});

	};

	LayoutService.getPageHeader()
	             .onClicked($scope.refresh);

	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/reports/serviceUsers/controller.js